import axios from "axios";
import Qs from "qs";
import { message } from "antd";
import { baseURL } from "./envConfig";
// axios 配置
axios.defaults.timeout = 20000;
axios.defaults.baseURL = baseURL;

// http request 拦截器
// axios.interceptors.request.use(
//     config => {
//         if (localStorage.getItem('token')) {
//             config.headers.Authorization =  `token=${localStorage.getItem('token')}`;    //添加了自定义头，后端没设置会一直显示跨域
//         }
//         return config;
//     },
//     err => {
//         alert('请求超时')
//         return Promise.reject(err);
// });

// // http response 拦截器
axios.interceptors.response.use(
  (response) => {
    // console.log('----',response)
    if (response.data.retCode === "000302") {
      localStorage.removeItem("token");
      localStorage.removeItem("mobile");
      // // localStorage.clear()
      window.location = "/login";
    }
    return response;
  },
  (err) => {
    console.log("-----", err);
    return Promise.reject(err);
    // window.location = '/#/login'
    // if (err.response.data.status == 504||err.response.data.status == 404) {
    //   alert('服务器被吃了')
    // } else if (err.response.data.status == 403) {
    //   alert('权限不足,请联系管理员')
    // }else if(err.response.data.status == 401){
    //   // 401 清除token信息并跳转到登录页面
    //   // store.commit(types.LOGOUT);
    //   //跳转到登录页面
    //   window.location = '/#/login'

    // }else {
    //     alert('未知错误')
    // }
    // console.log(JSON.stringify(err));//console : Error: Request failed with status code 402
    // return Promise.reject(err.response.data)
  }
);

let base = "/wispay";

if (baseURL.includes("192")) {
  base = "";
}
const post = (url, params) => {
  let data = Object.assign(
    {
      token: localStorage.getItem("token"),
      mobile: localStorage.getItem("mobile"),
    },
    params
  );
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: `${base}${url}`,
      data: data,
      transformRequest: [
        function (data) {
          return Qs.stringify(data, { allowDots: true });
        },
      ],
    })
      .then((res) => {
        try {
          if (res.data.success) {
            //操作类成功data为null
            resolve(res.data.data || { msg: res.data.retMsg });
          } else {
            message.error(res.data.retMsg);
            reject({ msg: res.data.retMsg });
          }
        } catch (error) {
          console.log(error);
          reject(error);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const get = (url, params) => {
  let data = Object.assign(
    {
      token: localStorage.getItem("token"),
      mobile: localStorage.getItem("mobile"),
    },
    params
  );

  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url: `${base}${url}`,
      params: data,
      paramsSerializer: function (params) {
        return Qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
      .then((res) => {
        try {
          if (res.data.success) {
            //操作类成功data为null
            resolve(res.data.data || { msg: res.data.retMsg });
          } else {
            message.error(res.data.retMsg);
            reject({ msg: res.data.retMsg });
          }
        } catch (error) {
          console.log(error);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const downExport = (url, params) => {
  let obj = Object.assign(
    {
      token: localStorage.getItem("token"),
      mobile: localStorage.getItem("mobile"),
    },
    params
  );

  let parmStr = "";
  for (let item in obj) {
    if (obj[item] == null || obj[item] == "undefined") {
      obj[item] = "";
    }
    parmStr += item + "=" + obj[item] + "&";
  }
  //   window.location.href = `http://test.zchpay.com${base}${url}?${parmStr}`
  window.location.href = `${base}${url}?${parmStr}`;
};

const requestGet = (url, params) => {
  let data = Object.assign(
    {
      token: localStorage.getItem("token"),
      mobile: localStorage.getItem("mobile"),
    },
    params
  );
  return axios({
    method: "get",
    url: `${base}${url}`,
    params: data,
    paramsSerializer: function (params) {
      return Qs.stringify(params, { arrayFormat: "repeat" });
    },
  })
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((err) => {
      console.log(err);
      return Promise.reject(err);
    });
};

const requestPost = (url, params) => {
  let data = Object.assign(
    {
      token: localStorage.getItem("token"),
      mobile: localStorage.getItem("mobile"),
    },
    params
  );
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: data,
    transformRequest: [
      function (data) {
        return Qs.stringify(data, { allowDots: true, skipNulls: true });
      },
    ],
  })
    .then((res) => {
      console.log(res);
      return Promise.resolve(res);
    })
    .catch((err) => {
      console.log(err);
      return Promise.reject(err);
    });
};
const requestFormDataPost = (url, params) => {
  let data = new FormData(); //通过FormData将文件转成二进制数据
  data.append("token", localStorage.getItem("token"));
  data.append("mobile", localStorage.getItem("mobile"));
  for (let key in params) {
    data.append(key, params[key]);
  }
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      console.log(res);
      return Promise.resolve(res);
    })
    .catch((err) => {
      console.log(err);
      return Promise.reject(err);
    });
};

/**
 * 自定义重命名下载
 * @param {arry} url 下载链接
 * @param {string} name 文件名称
 */
const renameDownload = (url, name) => {
  let fileName = name;
  getBlob(url).then((blob) => {
    DownloadItem(blob, fileName);
  });
};
const getBlob = (url) => {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (xhr.status === 200) {
        console.log(1111);
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
};
const DownloadItem = (blob, fileName) => {
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};

const downloadTemplate = async (url, params, filename = null) => {
  try {
    // 合并 token 和 mobile 参数
    const data = {
      token: localStorage.getItem("token"),
      mobile: localStorage.getItem("mobile"),
      ...params,
    };

    // 使用 await 等待 axios 响应
    const res = await axios({
      method: "get",
      url: `${base}${url}`, // 需要确保 base 变量已定义
      params: data,
      responseType: "blob",
    });

    // 从响应头获取文件名
    let fileName = filename;
    const contentDisposition = res.headers["content-disposition"];

    if (contentDisposition) {
      const match = contentDisposition.match(
        /filename\*?=["']?(?:UTF-8''|)([^"';]+)/i
      );
      if (match && match[1]) {
        fileName = decodeURIComponent(match[1]);
      }
    }

    // 如果没有获取到文件名，使用默认
    if (!fileName) {
      fileName = `download_${Date.now()}.xlsx`; // 默认文件名
    }

    // 创建 Blob 对象
    const contentType =
      res.headers["content-type"] || "application/octet-stream";
    const blob = new Blob([res.data], { type: contentType });

    // 创建下载链接
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName;

    // 触发下载
    document.body.appendChild(a);
    a.click();

    // 清理
    document.body.removeChild(a);
    window.URL.revokeObjectURL(downloadUrl);

    return { success: true, filename: fileName };
  } catch (error) {
    console.error("文件下载失败:", error);
    // 处理错误情况
    if (error.response) {
      // 如果后端返回了错误信息（也是 blob）
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const errorData = JSON.parse(reader.result);
          message.error(errorData.message || "下载失败");
        } catch {
          message.error("下载失败，请稍后重试");
        }
      };
      reader.readAsText(error.response.data);
    } else {
      message.error("网络异常，请检查连接");
    }
    return { success: false, error };
  }
};

export const request = {
  requestGet,
  requestPost,
  get,
  post,
  downExport,
  requestFormDataPost,
  renameDownload,
  downloadTemplate,
};
